import { Shield, BarChart3, Users, Clock } from 'lucide-react'
import { motion } from 'framer-motion'
import Card from '../ui/Card'
import Button from '../ui/Button'

const SolutionSection = () => {
  const solutions = [
    {
      icon: Shield,
      title: 'Evite Riscos',
      description: 'Evite riscos de erros, inconsistências no cálculo de horas e integre diversos sistemas de folha de pagamento de forma segura e confiável.',
      color: 'text-red-600 bg-red-100 dark:bg-red-900/30'
    },
    {
      icon: BarChart3,
      title: 'Relatórios Completos',
      description: 'Tenha acesso a mais de 20 relatórios completos e personalizados para tomar decisões estratégicas baseadas em dados reais.',
      color: 'text-blue-600 bg-blue-100 dark:bg-blue-900/30'
    },
    {
      icon: Users,
      title: 'Acompanhamento em Tempo Real',
      description: 'Acompanhe o status da jornada de trabalho do seu time em tempo real e de forma centralizada em uma única plataforma.',
      color: 'text-purple-600 bg-purple-100 dark:bg-purple-900/30'
    },
    {
      icon: Clock,
      title: 'Mais Tempo para Estratégia',
      description: 'Mais tempo para focar na estratégia ao automatizar processos operacionais e simplificar a rotina de trabalho do RH.',
      color: 'text-green-600 bg-green-100 dark:bg-green-900/30'
    }
  ]

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section id="solucao" className="py-20 bg-gray-50 dark:bg-gray-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 text-sm font-semibold mb-4">
            Nossa Solução
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Transforme a Gestão de Ponto da{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800">
              Sua Empresa
            </span>
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Uma solução completa que automatiza processos, reduz custos e aumenta a eficiência 
            do seu departamento de recursos humanos.
          </p>
        </motion.div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {solutions.map((solution, index) => {
            const Icon = solution.icon
            return (
              <motion.div
                key={solution.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card className="p-6 h-full hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group text-center">
                  <div className={`w-16 h-16 rounded-lg ${solution.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform mx-auto`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {solution.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                    {solution.description}
                  </p>
                </Card>
              </motion.div>
            )
          })}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <Button size="lg" onClick={scrollToContact}>
            Conhecer Todas as Funcionalidades
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

export default SolutionSection
